import Logo from "../img/logo3.png";
import { FaBars, FaTimes } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import LazyLoad from "react-lazy-load";
import SocialButton from "./Subassets/SocialButton";
import MobileNav from "./Subassets/MobileNav";

const Nav = (props) => {
  const { handleChange, getresume, open, navs } = props;
  return (
    <div className="">
      <header
        name="header"
        aria-label="header"
        className="sticky top-0 z-20 flex items-center justify-between w-full h-16 px-4 text-slate-200 backdrop-blur-sm bg-slate-800/90"
      >
        <h1 className="sr-only">Portfolio | Arun</h1>
        {/* logo */}

        <NavLink to="/" aria-label="home">
          <figure aria-label="logo">
            <LazyLoad>
              <img src={Logo} alt="logo" height="40" width="40" />
            </LazyLoad>
          </figure>{" "}
        </NavLink>

        {/* menu */}
        <nav aria-label="navigation links" className="hidden md:flex">
          <ul aria-label="link list" className="flex">
            {navs.map((nav) => (
              <li
                aria-label={nav.name}
                key={nav.id}
                className="outline-transparent"
              >
                <NavLink
                  className={({ isActive }) =>
                    isActive
                      ? "border-b-2 pb-1 border-cyan-600 text-teal-200 ease-in-out duration-300"
                      : undefined
                  }
                  to={nav.link}
                >
                  {nav.name}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
        {/* hamburger */}

        <button
          type="button"
          aria-label="hamburger"
          onClick={handleChange}
          className="z-30 text-3xl duration-1000 focus:outline-none md:hidden font-thinner active:rotate-90"
        >
          {!open ? (
            <span className="">
              <FaBars aria-label="open sidebar" />
            </span>
          ) : (
            <span className="">
              <FaTimes aria-label="close sidebar" />
            </span>
          )}
        </button>

        {/* mobile menu */}
        {open && (
          <MobileNav
            navs={navs}
            handleChange={handleChange}
            getresume={getresume}
          />
        )}
        {/* social links */}
        <SocialButton getresume={getresume} />
      </header>
    </div>
  );
};

export default Nav;
